import React from "react";

const SalonFranchiseSteps = () => {
  return (
    <div className="hairSalonInLavelleService">
      <h3>Steps to Open Your Salon Franchise in Bangalore with SCENT </h3>
      <p>
        Opening a{" "}
        <a href="https://scentlifestyle.com/beauty-salon-franchise-in-bangalore">
          Salon Franchise in Bangalore
        </a>{" "}
        with SCENT is a straightforward process designed to get you up and
        running quickly:
      </p>
      <li>
        <h6> 1. Initial Consultation:</h6>
        <p>
          Our team will discuss your goals, budget, and location preferences to
          determine the best strategy for your salon franchise.
        </p>
      </li>
      <li>
        <h6>2. Franchise Agreement:</h6>
        <p>
          Once the terms are agreed upon, we will sign a franchise agreement
          that outlines your responsibilities, the support you will receive, and
          other key details.
        </p>
      </li>
      <li>
        <h6> 3. Site Selection and Setup:</h6>
        <p>
          Our experts will help you choose the ideal location for your Salon
          Franchise in Bangalore, ensuring maximum visibility and foot traffic.
          We will also assist with the interior design, layout, and equipment
          setup to create a space that reflects the SCENT brand.
        </p>
      </li>
      <li>
        <h6>4. Training and Staffing:</h6>
        <p>
          Comprehensive training will be provided for you and your staff,
          covering all aspects of salon management, customer service, and beauty
          treatments.
        </p>
      </li>
      <li>
        <h6>5. Grand Opening:</h6>
        <p>
          We will support you with a grand opening event to create buzz and
          attract your first clients. From there, you will have ongoing support
          from our marketing, operations, and training teams.
        </p>
      </li>
    </div>
  );
};

export default SalonFranchiseSteps;
